'use client'

import { useQueryState } from 'nuqs'
import { useEffect, useState } from 'react'

export const useFormFieldValue = (fieldName: string, defaultValue?: string) => {
  const [urlValue, setUrlValue] = useQueryState(fieldName)
  const [fieldValue, setFieldValue] = useState(defaultValue || '')

  useEffect(() => {
    if (urlValue) {
      setFieldValue(urlValue)
    } else if (defaultValue) {
      setFieldValue(defaultValue)
    }
  }, [urlValue, defaultValue])

  // Ensure the URL param is set if defaultValue is present and urlValue is not
  useEffect(() => {
    if (!urlValue && defaultValue) {
      setUrlValue(defaultValue)
    }
  }, [urlValue, defaultValue, setUrlValue])

  return [fieldValue, setUrlValue] as const
}
